export default function Values() {
  const values = [
    {
      icon: 'ri-flashlight-line',
      title: 'Speed',
      description: 'Fast turnaround without sacrificing quality. Most projects done in 1–3 weeks.',
    },
    {
      icon: 'ri-message-3-line',
      title: 'Communication',
      description: 'Direct access to me. No account managers. Clear, honest updates.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Results',
      description: 'Websites built to convert visitors into customers. Every decision is intentional.',
    },
    {
      icon: 'ri-layout-4-line',
      title: 'Simplicity',
      description: 'Clean design. Easy to use. No unnecessary complexity or bloat.',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-sora font-bold text-5xl text-charcoal mb-4">
            What I Stand For
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm"
            >
              <div className="w-14 h-14 rounded-full bg-primary-light flex items-center justify-center mb-4">
                <i className={`${value.icon} text-2xl text-primary`}></i>
              </div>
              <h3 className="font-inter font-semibold text-xl text-charcoal mb-3">
                {value.title}
              </h3>
              <p className="font-inter text-base text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}